import React from "react"

const SectionHero = () => (
  <section className="hero2 sub-hero">
    <div className="wrap two">
      <div>
        <h1>Strengthen your TEAM performance before CMS reconciles</h1>
        <p className="lede">
          TEAM holds your hospital accountable for surgical episodes through 30
          days after discharge. We show where you stand against target and what
          to change.
        </p>
      </div>
      <div className="glance2 team">
        <div className="g-head">
          <span>TEAM at a glance</span>
          <em>Running now</em>
        </div>
        <div className="g-facts">
          <div>
            <b>5</b>
            <span>surgical categories</span>
          </div>
          <div>
            <b>30</b>
            <span>days after discharge</span>
          </div>
          <div>
            <b>2030</b>
            <span>model ends</span>
          </div>
        </div>
        <dl className="g-rows">
          <dt>Who</dt>
          <dd>
            Acute care hospitals in CMS-selected regions, plus hospitals that
            opted in
          </dd>
          <dt>Episodes</dt>
          <dd>
            CABG, lower extremity joint replacement, major bowel, surgical hip
            and femur fracture, spinal fusion
          </dd>
          <dt>Risk</dt>
          <dd>Track 1 is upside only. Tracks 2 and 3 are two-sided.</dd>
        </dl>
      </div>
    </div>
  </section>
)

export default SectionHero
